export const EMAIL_PATTERN = `^[a-zA-Z0-9](\\_?.?[a-zA-Z0-9]){3,}@((payfazz)?(gmail)?(ymail)?(rocketmail)?(yahoo)?(fazzfinancial)?)\\.com$`;
export const NAME_PATTERN = '^[a-zA-Z\\s-]+$';
export const PHONE_PATTERN = '^[0-9-+s()]{1,15}$';
